var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2507 4096 c-49 -18 -64 -32 -88 -77 -17 -35 -19 -61 -19 -294 0 -140 -3 -255 -8 -255 -36 0 -285 -34 -366 -50 -195 -40 -434 -119 -652 -216 -7 -3 -64 86 -135 208 -159 275 -164 283 -206 303 -48 23 -115 21 -157 -5 -47 -28 -80 -98 -73 -152 4 -33 145 -292 271 -501 9 -14 7 -20 -8 -29 -10 -6 -73 -51 -140 -101 -83 -63 -200 -169 -374 -341 -140 -138 -260 -263 -268 -278 -8 -15 -14 -47 -14 -71 0 -109 126 -190 221 -142 19 10 142 124 274 254 137 136 283 269 340 312 330 247 685 397 1100 466 85 14 165 18 355 18 190 0 270 -4 355 -18 260 -43 473 -110 700 -221 283 -139 426 -246 745 -562 129 -127 250 -240 269 -249 95 -48 221 33 221 142 0 24 -6 56 -14 71 -8 15 -128 140 -268 278 -174 172 -291 278 -374 341 -67 50 -130 95 -140 101 -15 9 -17 15 -8 29 126 209 267 468 271 501 7 54 -26 124 -73 152 -42 26 -109 28 -158 5 -40 -19 -50 -33 -206 -305 -62 -107 -116 -198 -120 -203 -3 -4 -40 8 -81 26 -174 80 -416 156 -609 192 -69 13 -314 45 -342 45 -5 0 -8 115 -8 255 0 235 -2 259 -20 294 -35 69 -121 103 -193 77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2442 2819 c-90 -11 -236 -59 -319 -105 -319 -178 -503 -532 -463 -891 39 -355 277 -650 615 -762 475 -157 986 99 1144 574 157 476 -98 985 -574 1144 -85 28 -231 52 -300 50 -16 -1 -63 -5 -103 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/openEye.fe83c2346065cf1baa4ac71f2692151c.svg";
export { ForwardRef as ReactComponent };